<template>
  <main>
    <div class="relative">
      <SectionHero variant="transparent-fixed" class="z-10 -md:!min-h-[calc(100svh_+_1px)] hero-main">
        <Hero :home="home" />
        <div
          v-if="insights.length != 0"
          class="insight-widgets-wrapper hidden md:block absolute isolate z-10 bottom-7 right-5"
        >
          <InsightWidget
            v-for="(insight, i) in insights"
            :id="insight.slug"
            :key="insight.id"
            :style="{
              '--index': `${insights.length - 1 - i}`,
              zIndex: i,
            }"
            :class="'insight-widget duration-500 pt-0.5 w-80 min-h-[104px] absolute right-0 bottom-0'"
            :img="insight.imagePreview || insight.image"
            :title="insight.title"
          />
        </div>
      </SectionHero>
      <div v-if="insights.length != 0" data-scroll-section class="z-30 absolute bottom-7 md:hidden w-full">
        <client-only>
          <swiper
            ref="swiper"
            data-scroll
            :options="{
              loop: true,
              autoplay: {
                delay: 0,
                disableOnInteraction: true,
              },
              speed: 6000,
              slidesPerView: 'auto',
              spaceBetween: 10,
              centeredSlides: true,
              freeMode: true,
              freeModeMomentum: true,
            }"
          >
            <swiper-slide v-for="insight in insights" :key="insight.id" class="!w-72 !h-[87px]">
              <InsightWidget :id="insight.slug" :img="insight.imagePreview || insight.image" :title="insight.title" />
            </swiper-slide>
          </swiper>
        </client-only>
      </div>
    </div>

    <SectionDefault>
      <Builder :blocks="blocks" :context="{ titleAnimation: 'rotation', insights }" />
    </SectionDefault>
  </main>
</template>

<script>
import Builder from '../components/builder/Builder'
import pageBuilder from '../components/mixins/pageBuilder.js'
import Hero from '../components/molecules/Hero'
import SectionDefault from '../components/templates/layouts/SectionDefault'
import SectionHero from '../components/templates/layouts/SectionHero'
import InsightWidget from '../components/molecules/InsightWidget.vue'
import logo from '~/assets/images/encore-logo-tv.png'

const mixinPageBuilder = pageBuilder({
  pageUrl: 'index',
  async fetch({ store, $axios }) {
    const id = `home`
    try {
      return {
        home: store.state.modules.content[id] || (await store.dispatch('modules/content/getContent', { id })) || {},
        insights: await $axios
          .get('api/article/carousel')
          .then(({ data }) => data ?? [])
          .catch(() => [])
          .then(insights => insights.sort(({ publishedAt: pub1 }, { publishedAt: pub2 }) => pub1.localeCompare(pub2))),
      }
    } catch (e) {
      return {}
    }
  },
})

export default {
  name: 'PageMain',
  components: {
    Builder,
    Hero,
    SectionDefault,
    SectionHero,
    InsightWidget,
  },
  mixins: [mixinPageBuilder],
  data() {
    return {
      home: {},
      insights: [],
    }
  },
  head() {
    return {
      script: [
        {
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'Encore Fitness',
            url: 'https://encorefitness.ru/',
            logo,
          },
        },
      ],
    }
  },
}
</script>

<style scoped>
.insight-widgets-wrapper .insight-widget {
  transform: translateY(calc(var(--index) * -6px)) scale(calc(1 - var(--index) * 0.04));
  filter: brightness(calc(1 - var(--index) * 0.05));
  transition-timing-function: cubic-bezier(0.18, 0.54, 0.27, 1.09);
}

.insight-widgets-wrapper:hover .insight-widget {
  transform: translateY(calc(-100% * var(--index))) scale(1);
  filter: brightness(1);
}
</style>
